// Define action types
export const SET_LOGIN_RESPONSE = 'SET_LOGIN_RESPONSE';

// Define action creators
export const setLoginResonse = (response) => ({
  type: SET_LOGIN_RESPONSE,
  payload: response,
});
